/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var addressToString = require('common/util/addressToString');

module.exports = function(formData, lookupHashes) {
  var deferred = $.Deferred();

  var entityTypes = lookupHashes.entityTypes || {};
  var organizationTypes = lookupHashes.organizationTypes || {};

  $.soap({
    body: {
      SubmitEntity: {
        $xmlns: 'http://dobs.pa.gov/co/entity/bpm/1.0',
        Name: formData.name,
        EntityTypeID: formData.entityTypeId,
        OrganizationTypeID: formData.organizationTypeId,
        Address: {
          AddressLine1: formData.addressLine1,
          AddressLine2: formData.addressLine2,
          City: formData.city,
          State: formData.state,
          County: formData.county,
          PostalCode: formData.postalCode,
          Country: formData.country
        },
        Website: formData.website
      }
    },
    blueprint: {
      newEntityId: '$..ID.__text',
      organizationTypeId: '$..OrganizationTypeID.__text',
      entityTypeId: '$..EntityTypeID.__text',
      website: '$..Website.__text',
      name: '$..Name.__text',
      addressLine1: '$..AddressLine1.__text',
      addressLine2: '$..AddressLine2.__text',
      addressLine3: '$..AddressLine3.__text',
      city: '$..City.__text',
      state: '$..State.__text',
      county: '$..County.__text',
      postalCode: '$..PostalCode.__text'
    }
  })
    .done(function(response) {
      // return to just the response.entityID; this change is because the presenter modal needs the
      // full object
      response.fullAddress = addressToString({
        addressLine1: response.addressLine1,
        addressLine2: response.addressLine2,
        addressLine3: response.addressLine3,
        city: response.city,
        state: response.state
      });

      if (response.entityTypeId) {
        response.entityType = entityTypes[response.entityTypeId];
      }

      if (response.organizationTypeId) {
        response.organizationType = organizationTypes[response.organizationTypeId];
      }

      deferred.resolve(response);
    })
    .fail(function() {
      deferred.reject();
    });

  return deferred.promise();
};
